import moment from 'moment-timezone';
import { useState, useEffect } from 'react';
import ms from 'ms';
import usePrevious from '../usePrevious';
import { areTimesEqual, calcTimeRemaining } from './utils';
const FLASHING_THRESHOLD_SECONDS = ms('2 minutes') / 1000;
const MAX_ELAPSED_TIME_SKEW_ALLOWED_MILLISECONDS = ms('2 minutes');
export default ({ currentServerTime = null, endTime, updateFrequency = 1000, }) => {
    const [startTime, setStartTime] = useState(currentServerTime);
    const previousStartTime = usePrevious(startTime, startTime);
    const previousEndTime = usePrevious(endTime, endTime);
    const [localTimestamp, setLocalTimestamp] = useState(moment());
    const [localElapsedTime, setLocalElapsedTime] = useState(0);
    const initialTime = calcTimeRemaining(startTime, endTime);
    const [baseTimeRemaining, setBaseTimeRemaining] = useState(initialTime);
    const [timeRemaining, setTimeRemaining] = useState(initialTime);
    useEffect(() => {
        if (!currentServerTime) {
            setStartTime(moment());
        }
        else {
            setStartTime(currentServerTime);
        }
    }, [currentServerTime]);
    useEffect(() => {
        if (!areTimesEqual(previousStartTime, startTime) ||
            !areTimesEqual(previousEndTime, endTime)) {
            const time = calcTimeRemaining(currentServerTime, endTime);
            setTimeRemaining(time);
            setBaseTimeRemaining(time);
            setLocalTimestamp(moment());
            setLocalElapsedTime(0);
        }
    }, [startTime, previousStartTime, endTime, previousEndTime]);
    useEffect(() => {
        if (Math.abs(localElapsedTime) > MAX_ELAPSED_TIME_SKEW_ALLOWED_MILLISECONDS) {
            setBaseTimeRemaining(Math.max(timeRemaining - Math.max(0, updateFrequency), -1000));
            setLocalTimestamp(moment());
            setLocalElapsedTime(0);
        }
    }, [localElapsedTime, timeRemaining, updateFrequency]);
    useEffect(() => {
        const updateElapsedTimeCallback = () => {
            setLocalElapsedTime(moment().diff(localTimestamp, 'milliseconds'));
        };
        updateElapsedTimeCallback();
        const intervalId = setInterval(updateElapsedTimeCallback, updateFrequency - 0.5);
        return () => clearInterval(intervalId);
    }, [updateFrequency, localTimestamp]);
    useEffect(() => {
        setTimeRemaining(Math.max(baseTimeRemaining - Math.max(0, localElapsedTime), -1000));
    }, [localElapsedTime, baseTimeRemaining]);
    const isElapsed = timeRemaining < 0;
    const shouldFlash = Math.floor(timeRemaining / 1000) <= FLASHING_THRESHOLD_SECONDS;
    return {
        secondsRemaining: Math.floor(timeRemaining / 1000),
        isElapsed,
        shouldFlash,
    };
};
//# sourceMappingURL=index.js.map